import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './modules/admin/admin.component';
import { PublicComponent } from './public/public.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';

const routes: Routes = [
    {
        path: '',
        component: PublicComponent
    },
    {
        path: 'veiculo/:idVehicle',
        component: VehicleDetailsComponent,
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'admin',
        children: [
            {
                path: '',
                component: AdminComponent,
                loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
        scrollOffset: [0, 0],
        anchorScrolling: 'enabled'
    })
    ],
    exports: [RouterModule]
})

export class AppRoutingModule { }